import _ from 'lodash'
import React, { useState, useEffect, useRef } from 'react'
import { Icon } from '@ant-design/compatible'
import { TablePaginationConfig } from 'antd/lib/table'
import { UdTable, http, UdFilter, IUdFormItem } from '@ud/admin-framework'
import SelectedShow from '../SelectedShow'
import DepartmentTree from '../DepartmentTree'
import SelfTabs from '../SelfTabs'
import JobsList from '../JobsList'
import '../modalPublicStyle.less'

const columns = [
  { title: '工号', dataIndex: 'jobNumber' },
  { title: '姓名', dataIndex: 'name' },
  {
    title: '性别', dataIndex: 'gender', render: (text: any) => {
      return text === 'MALE' ? '男' : '女'
    }
  },
  { title: '部门名称', dataIndex: 'mainPostName' },
]

const conditions: IUdFormItem[] = [
  {
    name: 'name', label: '姓名', col: { span: 12 }
  },
  {
    name: 'jobNumber', label: '工号', col: { span: 12 }
  },
]

const SelectPerson: React.FC<ISelectPersonProps> = (props) => {
  const [querying, setQuerYing] = useState<boolean>(false)
  const [dataSource, setDataSource] = useState<any[]>([])
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([])
  const [selectedRows, setSelectedRows] = useState<any[]>([])
  const [currentTabKey, setCurrentTabKey] = useState<string>('1')
  const [pagination, setPagination] = useState<TablePaginationConfig>({
    total: 0,
    current: 1,
    pageSize: 10
  })
  const [selectAllData, setSelectAllData] = useState<any[]>([])

  const tabList = [
    { name: '部门', id: '1' },
    { name: '岗位', id: '2' }
  ]

  const queryParams: any = useRef({ page: 1, size: 10 })

  const rowSelection: any = {
    onChange: (keysArr: any, rowArr: any) => {
      setSelectedRowKeys(keysArr)
      let arr: any = selectAllData
      rowArr = _.filter(rowArr, item=>!!item)
      arr.push(...rowArr)
      setSelectAllData(_.uniqBy(arr, 'jobNumber'))
    },
    selectedRowKeys,
    type: props.receiveData.rowSelectionType ? props.receiveData.rowSelectionType : 'checkbox'
  };

  const clickTab = (v: any) => {
    setCurrentTabKey(v)
    if (v === '2') {
      delete queryParams.current.directUnitUid
    } else if (v === '1') {
      delete queryParams.current.mainPostUid
    }
  }

  const handleSearch = (v: any) => {
    v.page = 1
    v.size = 10
    if (!v.name) {
      delete queryParams.current.name
    }
    if (!v.jobNumber) {
      delete queryParams.current.jobNumber
    }
    mergeQueryParams(v)
  }

  const filterReset = () => {
    let newParams = queryParams.current
    delete newParams.name
    delete newParams.jobNumber
    newParams.page = 1
    mergeQueryParams(newParams)
  }

  const handleTableChange = (v: any) => {
    mergeQueryParams({
      page: v.current
    })
  }

  const deleteSelect = (v: any) => {
    const newSelectedRowKeys = _.remove(selectedRowKeys, (n) => n !== v.jobNumber)
    const newSelectedRows = _.remove(selectedRows, (n) => n.jobNumber !== v.jobNumber)
    rowSelection.onChange(newSelectedRowKeys, newSelectedRows)
  }

  const emptySelect = () => {
    rowSelection.onChange([], [])
  }

  const mergeQueryParams = (ob: any) => {
    return new Promise<void>((resolve, reject) => {
      if (ob) {
        queryParams.current = _.merge(queryParams.current, ob)
        // console.log(queryParams.current)
        resolve()
      } else {
        reject()
      }
    }).then(() => {
      queryTableData()
    })
  }

  const queryTableData = () => {
    setQuerYing(true)
    http.post('/manage/org/query/employee', queryParams.current).then((res) => {
      let newPagination = {
        total: res.data.totalElements,
        current: res.data.number,
        pageSize: res.data.size
      }
      setQuerYing(false)
      setDataSource(res.data.content)
      setPagination(newPagination)
    })
  }

  useEffect(() => {
    props.getHandler(() => {
      return {
        selectedRowKeys,
        selectedRows: selectAllData,
        contentType: props.receiveData.contentType,
        otherParams: props.receiveData.otherParams || null
      }
    })
  })

  useEffect(() => {
    let arr: any = []
    selectedRowKeys.forEach((v) => {
      const item = _.find(selectAllData, n => n.jobNumber === v)
      if (item) {
        arr.push(item)
      }
    })
    console.log(arr)
    setSelectAllData(arr)
  }, [selectedRowKeys])

  useEffect(() => {
    const defaultData = props.receiveData.data
    if (defaultData && defaultData.selectedRowKeys && defaultData.selectedRows) {
      setSelectedRowKeys(defaultData.selectedRowKeys)
      setSelectAllData(defaultData.selectedRows)
    }
  }, [props.receiveData])

  return (
    <div className="select-modal-style">
      <div className="left">
        <SelfTabs tabList={tabList} clickTab={clickTab} />
        <div className="tree-box">
          {
            currentTabKey === '1' && <DepartmentTree selectTreeNode={(v: any) => {
              mergeQueryParams({ directUnitUid: v, page: 1, size: 10 })
            }} />
          }
          {
            currentTabKey === '2' && <JobsList selectJob={(v: any) => mergeQueryParams({ mainPostUid: v, page: 1, size: 10 })} />
          }
        </div>
      </div>
      <div className="content">
        <div className="search-box">
          {/* <SearchBox search={(v: any) => mergeQueryParams({ name: v })} placeholder="输入工号、姓名、账号、在当前选择的树节点下模糊查询" /> */}
          <UdFilter
            loading={querying} items={conditions}
            onSearch={handleSearch} onReset={filterReset}
          ></UdFilter>
        </div>
        <div className="table-box">
          <UdTable
            rowKey={"jobNumber"}
            keepSelectedRows={true}
            loading={querying}
            columns={columns}
            dataSource={dataSource}
            useColumnCustomize={false}
            useExport={false}
            onChange={handleTableChange}
            rowSelection={rowSelection}
            pagination={pagination}
          />
        </div>
      </div>
      <div className="right">
        <div className="title">
          已选人员
        </div>
        <div className="select-box">
          <SelectedShow deleteSelect={(v: any) => deleteSelect(v)} selectedRows={selectAllData} />
        </div>
        <div className="empty-box">
          <span onClick={emptySelect}>清空
            <Icon type="delete" />
          </span>
        </div>
      </div>
    </div>
  )
}

interface ISelectPersonProps {
  getHandler?: any
  receiveData?: any
}


export default SelectPerson